import useLoadingSpinner from '../../hooks/useLoadingSpinner';
import type { DatadogSpan } from '../../shared/datadog';

type FallbackProps = {
  span: DatadogSpan;
};

const MicroFallback = ({ span }: FallbackProps) => {
  const LoadingSpinner = useLoadingSpinner();
  span.addErrorEvent('Failure');
  return <LoadingSpinner />;
};

export default MicroFallback;
